export const transferHistoryEn = {};

export const transferHistoryFr = {};
